import React from "react";
import PropTypes from "prop-types";
import { Form } from "react-bootstrap";

export function ShowFilterRadioGroup({ value, onChange, name = "ShowFilter" }) {
  const handleChange = (event) => {
    if (onChange) {
      onChange(event.target.value);
    }
  };

  return (
    <div key={name} className="mb-3 mr-2">
      <Form.Check
        custom="true"
        type="radio"
        id={`${name}-ShowAll`}
        name={name}
        label="Show All Payers"
        value=""
        checked={value === ""}
        onChange={handleChange}
      />
      <Form.Check
        custom="true"
        type="radio"
        id={`${name}-ShowMfg`}
        name={name}
        label="Manufacturers Only"
        value="showmfg"
        checked={value === "showmfg"}
        onChange={handleChange}
      />
      <Form.Check
        custom="true"
        type="radio"
        id={`${name}-ShowThirdPartyIns`}
        name={name}
        label="Third-Party Insurance Only"
        value="showthirdpartyins"
        checked={value === "showthirdpartyins"}
        onChange={handleChange}
      />
    </div>
  );
}

ShowFilterRadioGroup.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  name: PropTypes.string,
};
